const shoppingCartDictIT = {
  productType: "Tipologia di prodotto:",
  soldBy: "Venduto da",
  pickUpInStore: "Ritira in negozio", // ritirare in negozio
  orderResume: "Riepilogo dell'ordine", // Riepilogo ordine
  shippingOptions: "Opzioni di spedizione",
  checkCatalog: "Approfitta delle offerte",
  emptyCartText: "Il tuo carrello della spesa è vuoto.",
  emptyCartSuggestion:
    "Accedi al nostro negozio e scopri tutti i vantaggi che Extraconomy ti offre.",
  percentualCreditInfo: "Informazioni sul credito percentuale",
  shop: "Negozio",
  searchProducts: "Cercare prodotti...",
  searchByTitleInThisSubcategory: "Cerca in questa sottocategoria...",
  byCap: "Di",
  product: "Prodotto",
  noResultsFound: "Nessun risultato trovato.",
  shoppingCart: "Carrello della spesa",
  cart: "Carrello",
  subtotal: "Totale provvisorio",
  onlyOneSeller: "Puoi acquistare solo prodotti da un venditore.",
  items: "articoli",
  platformFee: "Tariffa di piattaforma",
  total: "Totale",
  walletBalance: "Saldo attuale del tuo portafoglio",
  amountToPayWithWalletBalance: "Paga con il saldo del tuo portafoglio",
  amountToPayWithExtracredit: "Paga con Extracredit",
  sendYourTransferReceipt: "Inviare qui la prova del trasferimento",
  youWillNeedToTransfer: "È necessario trasferire",
  toTheBankAccount: "sul conto bancario",
  andUploadTheReceipt: "e caricare la ricevuta",
  finishOrder: "Finire l'ordine",
  finish: "Concludi",
  goToPayment: "Vai al pagamento",
  searching: "Ricerca",
  inSubcategory: "nella sottocategoria",
  inAllProducts: "in tutti i prodotti",
  productMaximumExtracoinPercent: "Percentuale massima di Extracredit (Prodotto)",
  userMaximumExtracoinPercent: "Percentuale massima di Extracredit (Utente)",
  checkout: "Memorizzare",
  amountToPayAtCheckout: "Valore da pagare alla cassa",
  orderData: "Dati di acquisto",
  howWillPay: "Come pagherai",
  otherMethods: "Altri metodi",
  creditRequested: "Credito richiesto",
  moreDetails: "più dettagli",
  productNotFound: "Prodotto non trovato. Prova a cercare nel nostro catalogo.",
  downloadableAndNonDownloadable:
    "I prodotti scaricabili e non scaricabili non possono trovarsi nello stesso carrello.",
  balanceAvailable: "Saldo Extracredit disponibile",
  freeExtracoinExplanation1: "Come",
  freeExtracoinExplanation2:
    "appena registrato, ti verrà concesso un pagamento completo di Extracredit gratuitamente nei tuoi primi tre ordini, il che significa che pagherai l'importo minimo di acquisto senza spendere i tuoi crediti Extracredit.",
  itemFavorited: "Articolo aggiunto ai preferiti.",
  itemRemovedFromFavorites: "Articolo rimosso dai preferiti.",
  info: "Info",
  searchForShipping: "Cerca le opzioni di spedizione per questo indirizzo postale",
  shippingQuotesFor: "Preventivi di spedizione per",
  pleasePickASendMethod:
    'Fai clic sul pulsante "Opzioni di spedizione" e seleziona un metodo di spedizione',
  shippingCost: "Spese di spedizione",
  searchAddress: "Auto Compila con CAP",
  shippingResponsibilitySeller: "La spedizione è responsabilità del venditore",
  plataformFeeExplanation: "La tariffa di piattaforma è del 5% del valore totale dei prodotti.",
  cashbackExplanation:
    "Qualsiasi importo non pagato in extracredit avrà il 50% convertito in cashback, tornando al tuo portafoglio in extracredit.",
  thankYouForYourPurchase: "Grazie per il tuo acquisto",
  pleaseFillAllFieldsAddressOrSearchShippingMethod:
    "Compila tutti i campi dell'indirizzo o fai clic su Opzioni di spedizione.",
  deliveryAddress: "Indirizzo di consegna",
  pickUpAddress: "Ritira il tuo ordine presso",
  orderId: "ID ordine",
  orderDate: "Data ordine",
  orderTotal: "Totale ordine",
  extraconomyExplain:
    "Hai la flessibilità di utilizzare il saldo Extracredit e/o il saldo del portafoglio per pagare il tuo ordine. Scegli qui sotto quanto desideri utilizzare da ciascuno per completare il tuo acquisto.",
  orderInformation: "Informazioni ordine",
  goToMyShoppings: "Vai ai miei acquisti",
  errorDontHavePhoneNumber:
    "Non hai un numero di telefono registrato. Inserisci il tuo numero di telefono e il codice telefonico nazionale per continuare.",
  insufficientFunds: "fondi insufficienti",
  errorCheckout:
    "Si è verificato un errore durante la finalizzazione dell'ordine. Contatta l'assistenza tramite WhatsApp al seguente numero. Non dimenticare di fornire le informazioni seguenti.",
  contactEmail: "Contattaci",
  yourOrderWillBeProcessed:
    "Il vostro ordine verrà rilasciato una volta confermato il trasferimento.",
  weWillNotifyYou: "Vi informeremo via e-mail dopo la conferma.",
  creditCardInfo: "Inserisci i dati del tuo carta di credito",
  error: "Errore",
  invalidCardDetails: "Compila correttamente i dati della tua carta di credito",
  confirmation: "Conferma",
  youDontHaveAddress: "Non hai ancora un indirizzo registrato",
  paymentFinished: "Pagamento effettuato con successo!",
  yourOrderWillBeReady: "Il tuo ordine verrà confermato quando riceveremo il tuo pagamento.",
  paymentDone: "Pagamento effettuato",
  orderDetailsCart: "Dettagli ordine",
  someItensMightBeDeliveredSeparately:
    "Alcuni articoli potrebbero essere consegnati separatamente.",
  invoiceAddress: "Indirizzo fattura",
  shipToMyAddress: "Spedisci al mio indirizzo",
  paypalPayment: "Pagamento con Paypal o direttamente nella tua carteira",
  myCredits: "I miei crediti",
  itemsRemoved: "Articolo rimosso dal carrello",
  combinePaymentMethods: "Combina 2 o più metodi di pagamento",
  combinePaymentExplanation:
    "Potrai combinare più di un metodo di pagamento per completare il tuo acquisto.",
  selectPaymentMethod: "Seleziona il metodo di pagamento",
  paymentTermsAcceptance:
    "Cliccando su Paga, accetti i nostri termini generali di utilizzo e i termini generali di vendita dei nostri commercianti.",
  payWithExtracreditAndWallet: "Paga con extracredito e saldo del portafoglio",
  payWithBankTransfer: "Paga con bonifico bancario",
  payWithCreditCard: "Paga con carta di credito",
  payWithPayPal: "Paga il tuo acquisto con PayPal",
  continueShopping: "Continua lo shopping",
  afterTransferUploadReceipt:
    "Dopo aver effettuato il bonifico, dovrai caricare la ricevuta qui sotto.",
  uploadReceipt: "Carica ricevuta",
  receiptUploadedSuccessfully: "Ricevuta caricata con successo!",
  removeReceipt: "Rimuovi ricevuta",
  bankTransferImportantNote:
    "Importante: i pagamenti tramite bonifico bancario non vengono elaborati automaticamente. Il nostro team verificherà per garantire la sicurezza della transazione.",
  paymentWithExtracredit: "Pagamento con Extracredit",
  toBeUsed: "da utilizzare",
  paymentWithWallet: "Pagamento con Saldo del Portafoglio",
  paymentCombination: "Combinazione di Pagamenti",
  paymentCombinationExplanation:
    "Puoi combinare i valori di extracredit e saldo del portafoglio per completare il tuo pagamento. Il valore totale deve essere uguale al valore dell'acquisto.",
  paymentCompleteWithOtherMethods: "Pagamento completo con altri metodi",
  paymentCompleteWithOtherMethodsExplanation:
    "L'importo totale è già stato coperto dagli altri metodi di pagamento selezionati.",
  totalAlreadyCovered: "Importo totale già coperto",
  methodNotAvailable: "Metodo non disponibile",
  methodNotAvailableExplanation: "Questo metodo di pagamento non è disponibile al momento.",
  noWalletBalanceAvailable: "Non hai saldo disponibile nel portafoglio",
  walletBalanceRequired:
    "Per utilizzare questo metodo di pagamento, devi avere saldo nel tuo portafoglio.",
  insufficientWalletBalance: "Saldo insufficiente",
  insufficientWalletBalanceMessage:
    "Il tuo saldo di {currency} {amount} non è sufficiente per pagare l'importo totale di {currency} {total}. Scegli un altro metodo di pagamento o attiva la modalità di combinare i pagamenti.",
  noExtracreditAvailable: "Non hai extracredit disponibile",
  extracreditRequired:
    "Per utilizzare questo metodo di pagamento, devi avere saldo nel tuo extracredit.",
  insufficientExtracredit: "Saldo insufficiente",
  insufficientExtracreditMessage:
    "Il tuo saldo di {currency} {amount} non è sufficiente per pagare l'importo totale di {currency} {total}. Scegli un altro metodo di pagamento o attiva la modalità di combinare i pagamenti.",
  extracreditAmountDescription:
    "Inserisci un importo che verrà utilizzato dal tuo saldo extracredit.",
  walletAmountDescription:
    "Inserisci un importo che verrà utilizzato dal saldo del tuo portafoglio.",
  modify: "Modificare",
  freight: "Spedizione",
  free: "Gratis",
  lookingTheBestShippingMethod: "Stiamo cercando il miglior metodo di spedizione",
  processingPayment: "Elaborazione pagamento...",
  userInfoDialogTitle: "Informazioni utente",
  userInfoDialogDescription:
    "Per continuare con il checkout, è necessario compilare alcune informazioni obbligatorie.",
  requiredUserInfo: "Dati di fatturazione",
  fillRequiredUserInfo: "Compila le informazioni obbligatorie",
  fillRequiredUserInfoDescription:
    "È necessario compilare alcune informazioni obbligatorie per continuare con il checkout (nome completo, telefono e documento di identificazione).",
  firstName: "Nome",
  lastName: "Cognome",
  surname: "Cognome",
  phone: "Telefono",
  invalidPhoneNumber: "Numero di telefono non valido",
  documentType: "Tipo di documento",
  enterYourFirstName: "Inserisci il tuo nome",
  enterYourLastName: "Inserisci il tuo cognome",
};

export default shoppingCartDictIT;
